import React from 'react'
import { MANUAL_SIMULATION, REMOTE_SIMULATION } from 'constants/sumilationConstants';
import Switch from "./../../../lib/react-switch/index";
import styles from './index.module.sass'
import { getSwitcherSize } from 'constants/commonContsnts';

interface Props {
  show: Boolean,
  isRemote: Boolean,
  blockToggler: Boolean,
  setSimulationType: Function
}

export const ControlType: React.FC<Props> = ({show, isRemote, blockToggler, setSimulationType}) => {
  const switchSize = getSwitcherSize()
  
  return (
    <div
      className={`${styles.controlType} ${show ? '' : styles.controlType_hidden}`}
    >
      <div className={styles.container}>
          <div onClick={() => !blockToggler && setSimulationType(isRemote ? MANUAL_SIMULATION : REMOTE_SIMULATION)} className={styles.icon}>
              {
                  isRemote ?
                    <div className={styles.remoteIcon}>
                        <div></div>
                        <div></div>
                    </div>
                    :
                    <div className={styles.manualIcon}>
                        <div></div>
                        <div></div>
                    </div>
              }
          </div>
      </div>
      <div className={styles.switch}>
          <div style={{width: '100%'}}>
              <div 
                  className={styles.contrWrapper}
                >
                <Switch 
                    height={switchSize.height}
                    togglerwidth={switchSize.togglerWidth}
                    activeBoxShadow={'unset'}
                    disabled={Boolean(blockToggler)}
                    width={switchSize.width}
                    onChange={() => setSimulationType(isRemote ? MANUAL_SIMULATION : REMOTE_SIMULATION)}
                    checked={!isRemote}
                    className={`${styles.switch} react-switch`}
                    uncheckedIcon={
                        <div className={`${styles.switch_text} ${styles.switch_text_right}`}>
                          remote
                        </div>
                      }
                    checkedIcon={
                        <div className={`${styles.switch_text} ${styles.switch_text_left}`}>
                          manual
                        </div>
                      }
                />
              </div>
          </div>
      </div>
    </div>
  )
}
